export class CapTrucThuoc {
    id: number;
    code: string;
    name: string; 
    displayOrder: number;
}